jQuery(function($){

	$('.slide-partners').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		// arrows: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
    });
});
